<template>
  <div id="main" class="main">
    <header class="page-header" v-if="$route.name == '/rent-subsidy/treaty'">
      <h2>校外賃居租金補貼申請</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li>賃居管理</li>
        </ol>
      </div>
    </header>
    <!-- 管理者 Tab 導航 -->
    <section class="panel panel-default" v-if="isSavable">
      <ul class="nav nav-tabs" role="tablist">
        <li><router-link :to="'/rent-subsidy/list'">申請清單</router-link></li>
        <li><router-link :to="'/rent-subsidy/timeSetting'">開放時間設定</router-link></li>
        <li class="active"><router-link :to="'/rent-subsidy/treaty'">設定隱私權宣告、申請資訊說明</router-link></li>
      </ul>
    </section>
    <section class="panel panel-default">
      <header class="panel-heading">
        <div class="panel-actions">
          <a href="javascript:" @click="() => {isEditPrivacy = !isEditPrivacy;}" v-if="this.isAdmin('tenancy')">編輯</a>
          <a href="#privacy" data-toggle="collapse" class="panel-action panel-action-toggle"
             @click="isViewPrivacy = true" v-if="!isSavable"></a>
        </div>
        <h1 v-show="!isEditPrivacy" class="panel-title">{{ model.PolicyAnnounce.title }} 第{{ model.PolicyAnnounce.version }}版</h1>
        <div v-show="isEditPrivacy" class="form-group">
          <label for="title">標題</label>
          <div>
            <input id="title" name="title" v-model="model.PolicyAnnounce.title" type="text" class="form-control"/>
          </div>
          <label for="version">版本</label>
          <div>
            <input id="version" name="version" v-model="model.PolicyAnnounce.version" type="text" class="form-control"/>
          </div>
        </div>
      </header>
      <div id="privacy" :class="!isSavable ? 'panel-collapse collapse in' : ''">
        <div class="panel-body" v-html="model.PolicyAnnounce.content" v-if="!isEditPrivacy"></div>
        <ckeditor v-model="model.PolicyAnnounce.content" :config="editorConfig" v-if="isEditPrivacy"></ckeditor>
      </div>
      <footer class="panel-footer" v-show="isViewPrivacy" v-if="!isSavable">
        <label class="s_agr">
          <input type="checkbox" v-validate="'required'" name="privacyCheckBox" v-model="privacyCheckBox">
          我同意以上{{ model.PolicyAnnounce.title }}
        </label>
        <span class="text-danger" v-show="errors.has('privacyCheckBox')">{{ errors.first('privacyCheckBox') }}</span>
      </footer>
    </section>
    <!-- 申請資訊說明 -->
    <section class="panel panel-default" v-if="isSavable">
      <header class="panel-heading">
        <div class="panel-actions">
          <a href="javascript:" @click="() => {isEditInfo = !isEditInfo;}" v-if="this.isAdmin('tenancy')">編輯</a>
        </div>
        <h2 class="panel-title">申請資訊說明</h2>
      </header>
      <div class="panel-body">
        <div v-html="model.InfoDescription.content" v-if="!isEditInfo"></div>
        <ckeditor v-model="model.InfoDescription.content" :config="editorConfig" v-if="isEditInfo"></ckeditor>
      </div>
    </section>
    <div class="col-md-12">
      <div class="s_tenc" v-if="!isSavable">
        <a @click="nextClick" class="btn-upload btn s_btn_b">下一步</a>
      </div>
      <div class="s_tenc" v-if="isSavable">
        <a @click="saveClick" class="btn-upload btn s_btn_b">儲存</a>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@/ckeditor4";

export default {
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      isSavable: false,
      privacyCheckBox: false,
      isViewPrivacy: true,
      isEditPrivacy: false,
      isEditInfo: false,
      model: {
        PolicyAnnounce: {},
        InfoDescription: { content: '' }
      },
      editorConfig: {
        extraPlugins: ["colorbutton"],
        height: 500,
        toolbar: [
          ["Source"],
          ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
          ["Undo", "Redo"],
          ["RemoveFormat"],
          ["NumberedList", "BulletedList"],
          ["Outdent", "Indent"],
          ["Blockquote"],
          ["Link", "Unlink", "Anchor"],
          ["Table", "HorizontalRule"],
          ["SpecialChar"],
          "/",
          ["Styles", "Format"],
          ["Bold", "Italic", "Strike"],
          ["TextColor", "BGColor"],
          ["Maximize"],
          ["About"]
        ]
      }
    };
  },
  mounted() {
    if (this.$route.name === "/rent-subsidy/treaty") {
      this.isSavable = true;
      document.querySelector("#main").classList.add("content-body");
    }
    this.$axios.get('/api/common/treaty?type=rent-subsidy').then(resp => {
      this.model = resp.data;
      this.model.PolicyAnnounce.content = this.htmlDecode(this.model.PolicyAnnounce.content);
      if (!this.model.InfoDescription) {
        this.model.InfoDescription = { content: '' };
      } else {
        this.model.InfoDescription.content = this.htmlDecode(this.model.InfoDescription.content);
      }
    });
  },
  methods: {
    nextClick() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$parent.step = 1;
        } else {
          bootbox.alert("請確認條約是否有打勾");
        }
      });
    },
    saveClick() {
      let errorMsgs = [];
      if (!this.model.PolicyAnnounce.content) {
        errorMsgs.push(`請填寫${this.model.PolicyAnnounce.title}`);
      }
      if (errorMsgs.length > 0) {
        bootbox.alert(errorMsgs.join("<br/>"));
        return false;
      }
      const formData = new FormData();
      formData.append("treaty", JSON.stringify({
        PolicyAnnounce: {
          title: this.model.PolicyAnnounce.title,
          version: this.model.PolicyAnnounce.version,
          content: this.htmlEncode(this.model.PolicyAnnounce.content)
        },
        InfoDescription: {
          content: this.htmlEncode(this.model.InfoDescription.content || '')
        }
      }));
      formData.append("type", "rent-subsidy");
      this.$axios.post('/api/common/saveTreaty', formData).then(resp => {
        bootbox.alert(resp.data.msg, () => {
          if (resp.data.status === "success") {
            this.$router.push('/rent-subsidy/list');
          }
        });
      });
    }
  }
};
</script>

<style scoped>
</style>
